import { StytchB2B } from '@stytch/react/b2b';
import MaximorLogoExpanded from 'assets/brand/dark_logo_expanded.svg';
import { discoveryConfig, discoveryStyles } from 'auth/stytch-config';

import { PrivacyPopup } from 'components/login/PrivacyPopup';

export function StytchLogin() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#164738]">
      <div className="w-full">
        <div className="flex justify-center mb-8">
          <img
            src={MaximorLogoExpanded}
            alt="Maximor Logo"
            className="h-8 w-auto object-contain"
          />
        </div>
        <div className="max-w-md mx-auto">
          <StytchB2B config={discoveryConfig} styles={discoveryStyles} />
        </div>
      </div>
      <PrivacyPopup />
    </div>
  );
}
